/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdDomainSettingsLauncherHubCustomPage
 */
export interface FxIdDomainSettingsLauncherHubCustomPage {
    /**
     * Title of the custom page in the hub
     * @type {string}
     * @memberof FxIdDomainSettingsLauncherHubCustomPage
     */
    Title?: string | null;
    /**
     * User will see a dot next to the title on the hub if the version is higher than
     * he saw last time in the hub
     * @type {number}
     * @memberof FxIdDomainSettingsLauncherHubCustomPage
     */
    Version?: number | null;
    /**
     * Url of the custom page iframe, you may pass fxid token to the iframe
     * @type {string}
     * @memberof FxIdDomainSettingsLauncherHubCustomPage
     */
    Url?: string | null;
    /**
     * Url of the custom page iframe, you may pass fxid token to the iframe
     * @type {boolean}
     * @memberof FxIdDomainSettingsLauncherHubCustomPage
     */
    HomePage?: boolean | null;
}

/**
 * Check if a given object implements the FxIdDomainSettingsLauncherHubCustomPage interface.
 */
export function instanceOfFxIdDomainSettingsLauncherHubCustomPage(value: object): value is FxIdDomainSettingsLauncherHubCustomPage {
    return true;
}

export function FxIdDomainSettingsLauncherHubCustomPageFromJSON(json: any): FxIdDomainSettingsLauncherHubCustomPage {
    return FxIdDomainSettingsLauncherHubCustomPageFromJSONTyped(json, false);
}

export function FxIdDomainSettingsLauncherHubCustomPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsLauncherHubCustomPage {
    if (json == null) {
        return json;
    }
    return {
        
        'Title': json['Title'] == null ? undefined : json['Title'],
        'Version': json['Version'] == null ? undefined : json['Version'],
        'Url': json['Url'] == null ? undefined : json['Url'],
        'HomePage': json['HomePage'] == null ? undefined : json['HomePage'],
    };
}

export function FxIdDomainSettingsLauncherHubCustomPageToJSON(json: any): FxIdDomainSettingsLauncherHubCustomPage {
    return FxIdDomainSettingsLauncherHubCustomPageToJSONTyped(json, false);
}

export function FxIdDomainSettingsLauncherHubCustomPageToJSONTyped(value?: FxIdDomainSettingsLauncherHubCustomPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Title': value['Title'],
        'Version': value['Version'],
        'Url': value['Url'],
        'HomePage': value['HomePage'],
    };
}

